var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.299 12.177a.249.249 0 01-.073-.177c0-.067.026-.13.073-.177l9.262-9.262A1.5 1.5 0 1021.437.44l-9.26 9.258a.253.253 0 01-.355 0L2.561.44A1.5 1.5 0 10.44 2.561l9.26 9.262a.252.252 0 01-.001.354L.44 21.439a1.501 1.501 0 00.673 2.51 1.5 1.5 0 001.449-.389l9.261-9.262a.25.25 0 01.354 0l9.261 9.262a1.5 1.5 0 102.122-2.12l-9.26-9.263z"
  })));
}
export default SvgCloseIcon;